import { render, staticRenderFns } from "./reg_first.vue?vue&type=template&id=f8179c1c&scoped=true"
import script from "./reg_first.vue?vue&type=script&lang=js"
export * from "./reg_first.vue?vue&type=script&lang=js"
import style0 from "./reg_first.vue?vue&type=style&index=0&id=f8179c1c&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8179c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8179c1c')) {
      api.createRecord('f8179c1c', component.options)
    } else {
      api.reload('f8179c1c', component.options)
    }
    module.hot.accept("./reg_first.vue?vue&type=template&id=f8179c1c&scoped=true", function () {
      api.rerender('f8179c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landingpage/reg_first.vue"
export default component.exports